export default {
  tag: "Historias Reales, Resultados Reales",
  title1: "Con la Confianza de Operadores de Food Trucks",
  title2: "En Todo el Condado de Orange",
  subtitle:
    "Más de 200 food trucks lanzados y contando. Esto es lo que nuestros clientes dicen sobre trabajar con My Food Truck Agency.",
  items: [
    {
      name: "Maria Reyes",
      role: "Propietaria, Taco Fuego OC",
      text: "No tenía idea de por dónde empezar con los permisos. My Food Truck Agency me guió por cada paso — desde la solicitud MFF hasta encontrar mi comisaría. ¡Abrimos en solo 10 semanas!",
      highlight: "Abrió en 10 semanas",
    },
    {
      name: "Derek Johnson",
      role: "Fundador, Seoul on Wheels",
      text: "El proceso de permisos en Anaheim fue una pesadilla hasta que llamé a estos chicos. Sabían exactamente qué formularios presentar, qué tarifas pagar, e incluso nos ayudaron a apelar con éxito una solicitud denegada.",
      highlight: "Revirtió una denegación de permiso",
    },
    {
      name: "Sandra & Luis Morales",
      role: "Copropietarios, Birria Bliss",
      text: "Desde la consulta de marca hasta encontrar nuestros primeros eventos privados, OCFTA cumplió con todo. Nuestro negocio creció de 1 camión a 3 en solo dos años. Increíblemente agradecidos.",
      highlight: "Creció a 3 camiones",
    },
    {
      name: "James Okafor",
      role: "Propietario, Naija Bites",
      text: "Como alguien nuevo en California, no tenía conocimiento de las regulaciones locales. OCFTA me dio una hoja de ruta clara y siempre respondió a mis preguntas. La mejor inversión que hice para mi negocio.",
      highlight: "Nuevo en California",
    },
    {
      name: "Ashley Kim",
      role: "Chef-Propietaria, Umami Pop",
      text: "El paquete de desarrollo de marca valió cada centavo. Nos ayudaron a diseñar una imagen que destaca en cada mercado. Los clientes constantemente elogian el diseño de nuestro camión.",
      highlight: "Identidad de marca destacada",
    },
    {
      name: "Carlos Vega",
      role: "Propietario, Tacos El Bueno",
      text: "Intenté navegar el código de salud del Condado de Orange por mi cuenta y fallé dos inspecciones. Después de una llamada con OCFTA, me ayudaron a arreglar todo y pasé mi siguiente inspección con excelencia.",
      highlight: "Pasó la inspección al primer intento",
    },
  ],
  ctaText: "¿Listo para escribir tu propia historia de éxito?",
  ctaButton: "Comienza Tu Viaje Hoy",
};